/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerPromotions200ResponseItemsInner
 */
export interface GetCustomerPromotions200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseItemsInner
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseItemsInner
     */
    redemptions: number;
}

/**
 * Check if a given object implements the GetCustomerPromotions200ResponseItemsInner interface.
 */
export function instanceOfGetCustomerPromotions200ResponseItemsInner(value: object): value is GetCustomerPromotions200ResponseItemsInner {
    if (!('redemptions' in value) || value['redemptions'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseItemsInnerFromJSON(json: any): GetCustomerPromotions200ResponseItemsInner {
    return GetCustomerPromotions200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'redemptions': json['redemptions'],
    };
}

export function GetCustomerPromotions200ResponseItemsInnerToJSON(json: any): GetCustomerPromotions200ResponseItemsInner {
    return GetCustomerPromotions200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseItemsInnerToJSONTyped(value?: GetCustomerPromotions200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'redemptions': value['redemptions'],
    };
}

